module.exports = __webpack_public_path__ + "static/media/bonyan-logo-only.5c9d0408.png";